<script>
import Rating from "@/components/rating.vue";
export default {
  components: {
    Rating
  },
  props: {
    rating: {
      type: Number,
      default: 0
    }
  },
  methods: {
    setRating(value) {
      this.$emit("update-rating", value);
    },
    handleRate(event) {
      const mousePosition = event.clientX;
      const container = this.$refs.ratingContainer;
      const containerRect = container.getBoundingClientRect();
      const relativeX = mousePosition - containerRect.left;
      const containerWidth = containerRect.width;
      const newRating = Math.ceil((relativeX / containerWidth) * 5);
      this.setRating(newRating);
    }
  }
};
</script>
<template>
  <div @click.stop="handleRate" ref="ratingContainer" class="rate-user">
    <Rating :rating="rating || 0" />
  </div>
</template>
<style scoped lang="scss">
.rate-user {
  cursor: pointer;
}
</style>
